module.exports = __webpack_public_path__ + "static/media/guvi.08cb9079.png";